import { render, staticRenderFns } from "./formLeadExterna.vue?vue&type=template&id=633b9c78&scoped=true"
import script from "./formLeadExterna.vue?vue&type=script&lang=js"
export * from "./formLeadExterna.vue?vue&type=script&lang=js"
import style0 from "./formLeadExterna.vue?vue&type=style&index=0&id=633b9c78&prod&lang=scss"
import style1 from "./formLeadExterna.vue?vue&type=style&index=1&id=633b9c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b9c78",
  null
  
)

export default component.exports